import { render, staticRenderFns } from "./CampanhasList.vue?vue&type=template&id=37bd4fa9&scoped=true&"
import script from "./CampanhasList.vue?vue&type=script&lang=js&"
export * from "./CampanhasList.vue?vue&type=script&lang=js&"
import style0 from "./CampanhasList.vue?vue&type=style&index=0&id=37bd4fa9&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37bd4fa9",
  null
  
)

export default component.exports